<script>
/**
 * Left sidebar component - contains mainly the application menu
 */
import {
  getFirestore,
  collection,
  getDocs,
  query,
  orderBy,
  where,
  doc,
  getDoc
} from 'firebase/firestore/lite'
import CryptoJS from 'crypto-js'

import { firebase } from '../firebase-int'
const firestore = getFirestore(firebase)

export default {
  props: {
    content: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    parentContent: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    grandParentContent: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    index: {
      type: Number,
      required: false,
      default: () => ({}),
    },
    pointsArray: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cId:{
      type: String,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      isItemLocked:true,
      subChapterCount:0,
      disabled: false,
      userSubChapters:[]
    }
  },
  methods: {
    getAccessLevelColor(item) {
      if (item === 'Administrator') return 'badge-soft-danger'
      else if (item === 'Editor') return 'badge-soft-secondary'
      else if (item === 'User') return 'badge-soft-success'
      else if (item === 'Union Administrator') return 'badge-soft-primary'
      else if (item === 'Federation Administrator') return 'badge-soft-info'
      else return 'badge-soft-dark'
    },
    myRowClickHandler(cId, content, parentContent, grandParentContent) {
      if (this.isItemLocked) 
      {
        console.log(
          '>>>>>>>>>>>>>>>>>>>>>>>>>>>> index: ' +
            content.id +
            ' - ' +
            content.title
        )
        this.warnDisabled()
      } 
        else
        this.$router.push({
          name: 'ContentScreen',
          params: {
            content: content,
            id: content.id,
            parentContent: parentContent,
            grandParentContent: grandParentContent,
            cId:cId
          },
        })
      
    },
    getCourseIndex() {
      var currentIndex = 0
      for (
        let i = 0;
        i < this.$store.state.auth.currentUser.courseList.length;
        i++
      ) {
        if (
          this.grandParentContent.id ==
          this.$store.state.auth.currentUser.courseList[i]
        ) {
          currentIndex = i
          //console.log('>>>>>>>>>>>> Got in for loop: ' + currentIndex)
        }
      }
      return currentIndex
    },
    async getUserSubChaptersProgress()
    {
      const docRef = doc(firestore, "member", this.$store.state.auth.currentUser.id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        //console.log("Document data:", docSnap.data());
        if(docSnap.data().subchapters)
        {
          this.userSubChapters=docSnap.data().subchapters
          //this.userProgress=docSnap.data().progress
        }
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    },
    isLocked() {
      var isLockedValue=true
      if(this.content.cid==1)
      return false
      else
      {
        if(this.userSubChapters)
        this.userSubChapters.forEach(element => {
          if(element.includes(this.content.id))
          //console.log('>>>>>>>>> Comparison: element: '+element+' | '+this.content.id)
          isLockedValue=false
        });
      }
      
      return isLockedValue
      //return false
    },
    warnDisabled() {
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 1500)
    },
   /*  getPercentage() {
      if (this.isLocked()) return 0
      else {
        var subchapterLength = this.content.content.length
        var currentSubChapterIndex =
          this.$store.state.auth.currentUser.ucsc[this.getCourseIndex()]
        return (currentSubChapterIndex / subchapterLength) * 100
      }
    }, */
    getPercentage()
    {
      var divider=this.pointsArray.totalDividers
      if(divider<=0)
      divider=1
      var value=Math.ceil((this.pointsArray.totalPoints/divider)*100)
      if(value>100)
      value=100

      return value
    }
  },
  computed: {},
  watch: {},
  async mounted() {
    //console.log('>>>>>> Image file: '+this.cId)
    await this.getUserSubChaptersProgress()
    this.isItemLocked=false
    this.subChapterCount=this.parentContent.subchapters.length
      //console.log('>>>>>> subchapter count: '+this.subChapterCount)
    this.isItemLocked=this.isLocked()
  },
}
</script>

<template>
  <a
    @click="myRowClickHandler(cId, content, parentContent, grandParentContent)"
    style="cursor: pointer"
  >
    <div class="cardd">
      <!--div v-if="content.coverImage"  class="card-img">
        <image-loader
          :src="content.coverImage"
          placeholder="../assets/images/loaders/loading.gif"
          width="100%"
          height="100%"
          style="border-radius: 16px"
        />
      </div-->
      <div class="card-img">
        <image-loader
          src="https://firebasestorage.googleapis.com/v0/b/gebi-b0e0c.appspot.com/o/placeholder.jpg?alt=media&token=c47dd29e-01db-408e-92bb-fa41a34c1d07"
          placeholder="../assets/images/loaders/loading.gif"
          width="100%"
          height="100%"
          style="border-radius: 16px"
        />
        <!--VueLoadImage>
          <img slot="image" src="../assets/images/placeholder.jpg" height="350px"/>
          <img slot="preloader" src="../assets/images/loaders/loading.gif" />
          <div slot="error">error message</div>
        </VueLoadImage-->
      </div>
      <div v-if="isItemLocked" class="desc" :class="{ shake: disabled }">
        <img
          src="../assets/images/locked-padlock-.png"
          alt="locked"
          width="40px"
          height="40px"
        />
        <span v-if="disabled">&nbsp;&nbsp;</span>
        <span v-if="disabled">This content is locked!</span>
      </div>
      <div class="details">
        <div style="width: 100%; height: 100%">
          <h6 class="primary-text">{{ content.title }}</h6>
          <h6 class="secondary-text">{{ content.description }}</h6>
          <div class="bottom">
            <div>&nbsp;</div>
            <div id="textbox">
              <p class="alignleft">Covered so far</p>
              <p class="alignright">{{getPercentage()}}%</p>
              <!--p class="alignright">{{getPercentage()}}% - ({{this.pointsArray.totalPoints}}/{{this.pointsArray.totalDividers}})</p-->
            </div>
            <b-progress
              :value="pointsArray.totalPoints"
              :max="pointsArray.totalDividers"
              class="mb-3"
              variant="warning"
              height="8px"
            ></b-progress>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<style lang="scss">
.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
#textbox {
  display: flex;
  flex-flow: row wrap;
}
.alignleft {
  width: 50%;
  text-align: left;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}
.alignright {
  width: 50%;
  text-align: right;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}
.cardd {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  border-radius: 16px;
  margin-bottom: 16px;
  //box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
}
.card-img {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  margin: 0px auto 0px auto;
  left: 0;
  right: 0;
  border-radius: 16px;
}
.card-img img {
  height: 100%;
  width: 100%;
  border-radius: 16px;
  object-fit: cover;
}
.desc {
  width: 100%;
  text-align: left;
  position: absolute;
  top: 16px;
  left: 16px;
}
.primary-text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0.7px;
  margin: 5px 0;
  text-shadow: 1px 1px #000000;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.secondary-text {
  color: #ffffff;
  font-weight: 100;
  font-size: 12px;
  letter-spacing: 1px;
  margin: 5px 0;
  text-overflow: ellipsis;

  line-height: 1.5em;
  height: 4.5em;
  overflow: hidden;
}
.coveredSoFar {
  width: 100%;
  font-weight: 100;
  font-size: 12px;
  line-height: 30px;
}
.bottom {
  width: 100%;
  display: inline-block;
  align-self: flex-end;
}
.details {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.185);
  backdrop-filter: blur(10px);
  border-radius: 0 0 16px 16px;
  padding: 15px;
  display: flex;
}
.details > div {
  text-align: left;
}
.buttonn {
  background-color: rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  position: absolute;
  width: 80%;
  left: 10%;
  top: 240px;
  border: none;
  border-radius: 5px;
  padding: 15px 0;
}
.coffe {
  position: absolute;
  left: 50px;
  bottom: 50px;
  transition: all 0.6s ease-in-out;
}
.coffe:hover {
  transform: scale(1.2);
}

.fs-12 {
  font-size: 10px !important;
}
.custom_badge {
  display: inline-block;
  padding: 0.25 em 0.4 em;
  font-size: 70%;
  font-weight: 500;
  line-height: 1.2;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.75 rem;
}

.custom_card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1 px solid #e2e7f1;
  border-radius: 0.25 rem;
}

.custom_img {
  border-radius: 16px 16px 0px 0px;
  object-fit: contain;
  display: flex;
  width: 100%;
  height: 100%;
}

.custom_loader_img {
  border-radius: 5px 5px 0px 0px;
  height: 140px;
  object-fit: scale-down;
  display: block;
  width: 100%;
}

.custom_card-body {
  flex: 1 1 auto;
  padding: 15px 25px 5px 0px;
}

.custom_align-items-left {
  align-items: left !important;
}

.col-sm-auto {
  flex: 0 0 auto;
  width: auto;
}
</style>
